import { AxiosError } from "axios"
import { useQuery } from "react-query"
import { SwitchingBenchmark } from "../interfaces"
import { RequestParameters } from "components/Shared/Filters/interfaces"
import { getSwitchingBenchmarkInformation } from "../service"
import { isNotEmpty } from "./utils"

const SWITCHING_BENCHMARK_QUERY = "switchingBenchmarkQuery"

const validateFilters = (filters: RequestParameters): boolean => {
	const {
		departments,
		categories,
		previousFrom = "",
		previousTo = "",
		currentFrom = "",
		currentTo = "",
		vendors,
	} = filters
	return [
		departments,
		categories,
		vendors,
		previousFrom,
		previousTo,
		currentFrom,
		currentTo,
	].every(isNotEmpty)
}

export const useGetSwitchingBenchmarkInformation = (
	filters: RequestParameters
) => {
	const {
		isLoading: isPendingRequest,
		data,
		isError,
		error,
		refetch,
		isSuccess,
		isIdle,
	} = useQuery<SwitchingBenchmark, AxiosError>(
		[SWITCHING_BENCHMARK_QUERY, filters],
		() => getSwitchingBenchmarkInformation(filters),
		{
			enabled: validateFilters(filters),
			retry: false,
			refetchOnReconnect: false,
			refetchOnWindowFocus: false,
		}
	)
	return {
		isPendingRequest,
		data,
		isError,
		error,
		refetch,
		isSuccess,
		isIdle,
	}
}
